import { handleTrackClick } from "~lib/analytics/handleTrackClick";
import { usePageData } from "~core/hooks/use-page";
import TalkIcon from "~features/discussion/TalkIcon";
import { cx } from "~utils";
import styles from "./DiscussionModule.module.css";

export default function DiscussionModule() {
  const { discussionList } = usePageData();
  const discussionTopics = discussionList?.results;

  function handleDiscussionPageClick(e) {
    handleTrackClick("homepage-discussionmodule-topic-link-click", e);
  }

  function handleViewAllDiscussionsClick(e) {
    handleTrackClick("homepage-discussionmodule-view-all-discussions-link-click", e);
  }

  return (
    <>
      {discussionTopics && (
        <>
          <div className={styles.discussion__hp__module__container}>
            <div className={styles.discussion__hp__module__body}>
              <section className={styles.discussion__hp__module__topic__hdr__wrap}>
                <h2 className={styles.discussion__hp__module__topic__hdr}>Discussions</h2>
              </section>
              <section className={styles.discussion__hp__module__wrap}>
                {discussionTopics.map((discussion, idx) => (
                  <div
                    key={`discussion-` + discussion.id}
                    className={styles.discussion__hp__module__thread}
                  >
                    <div className={styles.discussion__hp__module__thread__title}>
                      <a
                        href={discussion.url}
                        className={styles.discussion__hp__module__thread__title__lnk}
                        onClick={handleDiscussionPageClick}
                      >
                        {discussion.title}
                      </a>
                    </div>
                    <div className={styles.discussion__hp__module__icon__time__wrap}>
                      <div>
                        <TalkIcon
                          svgClassName={"discussion__hp__module__talk__icon__svg"}
                          pathClassName={"discussion__hp__module__talk__icon__path"}
                        />
                        <span className={styles.discussion__hp__module__thread__count}>
                          {discussion.post_count}
                        </span>
                        <span className={styles.discussion__hp__module__view__discussion__wrap}>
                          <a
                            href={discussion.url}
                            className={styles.discussion__hp__module__view__discussion__lnk}
                            onClick={handleDiscussionPageClick}
                          >
                            View the Discussion
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </section>
              <a
                href={"/discussions/"}
                className={styles.discussion__hp__module__view__all__lnk}
                onClick={handleViewAllDiscussionsClick}
              >
                View All Discussions
              </a>
            </div>
          </div>
        </>
      )}
    </>
  );
}
